import { render, staticRenderFns } from "./DataMetricsBadge.vue?vue&type=template&id=442957a9&scoped=true&shadow"
import script from "./DataMetricsBadge.vue?vue&type=script&lang=js&shadow"
export * from "./DataMetricsBadge.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "442957a9",
  null
  ,true
)

export default component.exports